export interface Ga4Item {
  item_id: string
  sku?: string
  item_name: string
  index?: number
  item_brand?: string
  item_category?: string
  item_list_id?: string
  item_list_name?: string
  price?: number
  quantity?: number
}

export function mapProductToGa4Item(params: {
  product: any
  index?: number
  listId?: string
  listName?: string
  positionStartsAtOne?: boolean
}): Ga4Item | null {
  const { product, index, listId, listName, positionStartsAtOne } = params
  if (!product) return null

  // Ta första varianten
  const variant =
    product?.variants?.edges?.[0]?.node ||
    product?.variants?.[0] ||
    null

  if (!variant) return null

  const pos =
    typeof index === 'number'
      ? (positionStartsAtOne ? index + 1 : index)
      : undefined

  const priceNum = parseFloat(
    variant?.price?.amount ||
      product?.priceRange?.minVariantPrice?.amount ||
      '0'
  )

  // Extract product ID from gid://shopify/Product/{id} format
  let productId = product.id
  if (productId && typeof productId === 'string' && productId.includes('gid://shopify/')) {
    productId = productId.split('/').pop() || productId
  }

  return {
    item_id: productId,
    sku: variant.sku || undefined,
    item_name: product.title,
    index: pos,
    item_brand: product.vendor || 'Gravaa',
    item_category: product.productType || undefined,
    item_list_id: listId,
    item_list_name: listName,
    price: priceNum,
    quantity: 1
  }
}